import React from "react";
import PropTypes from "prop-types";

import { CustomButton } from "../Buttons";
import { AddIcon, EmptyStates } from "@/asset/icons";
import Background from "../Paper/Background";

const EmptyCard = ({
    title = "No data available",
    subtitle,
    buttonText,
    emptyIcon,
    onClick,
    noStartIcon = false,
    extraButtons,
}) => {
    return (
        <Background
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "10px",
                height: "500px",
            }}
        >
            <div
                role="region"
                aria-label="Empty state"
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "10px",
                    textAlign: "center",
                    padding: "20px",
                }}
            >
                {emptyIcon ? (
                    emptyIcon
                ) : (
                    <EmptyStates.EmptyNotificationIcon />
                )}

                <p style={{
                    fontSize: "14px",
                    fontWeight: 600, 
                    color: "#101828",
                    margin: 0
                }}>
                    {title}
                </p>

                {subtitle && (
                    <p
                        style={{
                            fontSize: "14px", 
                            whiteSpace: "pre-line",
                            fontWeight: 400,
                            color: "#A0A4A8",
                            textAlign: "center",
                            margin: 0
                        }}
                    >
                        {subtitle}
                    </p>
                )}

                <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
                    {buttonText && (
                        <CustomButton
                            variant="contained"
                            icon={<AddIcon/> }
                            onClick={onClick}
                        >
                            {buttonText}
                        </CustomButton>
                    )}

                    {extraButtons}
                </div>
            </div>
        </Background>
    );
};

EmptyCard.propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    buttonText: PropTypes.string,
    emptyIcon: PropTypes.node,
    onClick: PropTypes.func,
    noStartIcon: PropTypes.bool,
    extraButtons: PropTypes.node,
};

export default EmptyCard;